import type { CalendarItem } from '@/types/contentPlanner';

export type GroupKey = 'pinned' | 'progress' | 'queue';

export function deriveGroup(item: CalendarItem): GroupKey {
  // TODO(content-planner-redesign): no `is_pinned` field on CalendarItem yet — Pinned group is empty in v1.
  // `pending` blogs are freshly-queued generations (isProcessing-true in the
  // canonical set) — keep them in "In Progress" (top) so they don't sink into
  // the Backlog group while they generate.
  if (item.status == null) return 'queue';
  return 'progress';
}
